import { Header } from "#components";
import React from "react";

const AdminLayout = ({ children }) => {
  return (
    <div className="main-wrapper">
      <Header />
      <div className="content-wrapper">{children}</div>
    </div>
  );
};

export default AdminLayout;
